// Mapping of data attributes to their respective script URLs
const scriptMap = {
  'before-after-octopus': '/octopus-public/assets/beforeAfterOctopus.js',
  'carousel': '/octopus-public/assets/carousel.js',
  'content-with-sidenav': '/octopus-public/assets/contentWithSidenav.js',
	'customer-story-filter': '/octopus-public/assets/customerStoryFilter.js',
	'bg-url': '/octopus-public/assets/lazyBackgroundLoader.js',
  'integrations': '/octopus-public/assets/integrations.js',
  'job-offers': '/octopus-public/assets/jobOffers.js',
	'lottie':  '/octopus-public/assets/lottie.js',
  'navbar-PU': '/octopus-public/assets/navbarPU.js',
	'pricing-select': '/octopus-public/assets/pricingSelect.js',
	'product-highlight': '/octopus-public/assets/productHighlight.js',
	'storyblok-image': '/octopus-public/assets/imageDimensionSetter.js',
	'tooltip': '/octopus-public/assets/tooltip.js',
	'video': '/octopus-public/assets/video.js',
	'webinars': '/octopus-public/assets/webinarShowMore.js',
  '.mktoFormWrapper': '/octopus-public/assets/dropdownWidthAdjuster.js',
};

function loadScript(url) {
  const script = document.createElement("script");
  script.src = url;
  script.defer = true;
  script.onerror = function () {
    console.error("Script failed to load: " + url);
  };
  document.body.appendChild(script);
}

export function initializeScripts() {
  Object.entries(scriptMap).forEach(([selector, url]) => {
    // Check for class-based selectors
    if (selector.startsWith('.')) {
      if (document.querySelector(selector)) {
        loadScript(url);
      }
    } else {
      if (document.querySelector(`[data-${selector}]`)) {
        loadScript(url);
      }
    }
  });
}
